import { system } from './system-core.esm.js';
import elevationTransform from '../theme-provider/elevation-transform.esm.js';
import lhCropTransform from '../theme-provider/lh-crop-transform.esm.js';

var truncateOverflow = function truncateOverflow(maxLine) {
  return "\n-webkit-box;\n-webkit-line-clamp: ".concat(maxLine, ";\n/*! autoprefixer: ignore next */\n-webkit-box-orient: vertical;\noverflow: hidden;\n");
};
var stylableProps = {
  columns: true,
  spacing: true,
  transform: true,
  elevation: {
    property: 'boxShadow',
    scale: 'shadows',
    transform: elevationTransform
  },
  lhCrop: {
    property: 'paddingTop',
    scale: 'lhCrops',
    transform: lhCropTransform
  },
  maxLine: {
    property: 'display',
    scale: 'lineHeights',
    transform: function transform(value) {
      return value ? truncateOverflow(value) : '';
    }
  }
};
var stylable = system(stylableProps);

export default stylable;
export { stylable };
//# sourceMappingURL=stylable.esm.js.map
